import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {UtilService} from "../../services/util.service";
import {StateService} from "../../services/state.service";
import {User, UserRole} from "../../models/user";
import {MatTable, MatTableDataSource} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {catchError, EMPTY, finalize, Subject, takeUntil, throwError} from "rxjs";
import {HttpService} from "../../services/http.service";
import {Router} from "@angular/router";
import {CaseStatus, ProtestInfo} from "../../models/protest";
import {MatSelectChange} from "@angular/material/select";
import {MatDialog, MatDialogRef } from '@angular/material/dialog';
import {UserInvitation, UserInvitationsComponent } from './user-invitations/user-invitations.component';
import {CaseDocketService} from "../../services/case-docket.service";


export interface DashboardResponse {
  caseStatusList: CaseStatus[],
  dashboardDtoList: DashboardDto,
  displayProtestTable: boolean,
  gaoUserList: User[],
  numberOfDaysLeftToExpirePwd: number,
  protest_Info_List: ProtestInfo[],
  role: UserRole,
  unjoinedProtestInfoList: ProtestInfo[],
  userProfileInfo: User
}

export interface DashboardDto {
  alreadyAvailableANums: Array<any>,
  attorneyGroupIds: Array<any>,
  caseStatusList: CaseStatus,
  endLimit : number,
  fullReloadReq: boolean,
  startLimit: number
}

interface FilterValues {
  global: string,
  group: number | undefined,
  user: string,
  status: string[]
}

interface IUList {
  invitedUserList: UserInvitation[];
}
@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    standalone: false
})

export class DashboardComponent implements OnInit, AfterViewInit, OnDestroy {
  protected ngUnsubscribe = new Subject<void>();

  @ViewChild(MatTable) table!: MatTable<ProtestInfo>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  displayedColumns: string[] = [];
  dataSource = new MatTableDataSource<ProtestInfo>();
  option: any;
  pageLocalStorageKey = "dashboard_page_size";
  dashboardFilterStatusLSKey = "dashboard_filter_status_" + this.stateService.user.user_Id;
  alreadyAvailableANums = "";
  showEmailButton = false;
  emailButtonText = "Clear";
  showGroupAttorneyFilters = false;

  filterAttorneyList : string[] = [];
  filterGroupList : number[] = [];
  filterCaseStatusList : string[] = [];

  filterValues : FilterValues = {
    global: '',
    group: undefined,
    user: '',
    status: []
  }

  filterValuesStatusOldLength! : number;
  filterValuesStatusOld! : string[];

  loading = false;

  constructor(public util: UtilService,
              private httpService: HttpService,
              private stateService: StateService,
              private router: Router,
              private dialog: MatDialog,
              private caseDocketService: CaseDocketService) {
  }

  ngOnInit(): void {
    if (this.stateService.dashType == "unassigned") {
      this.pageLocalStorageKey = "unassigned_" + this.pageLocalStorageKey;
      this.dashboardFilterStatusLSKey = "unassigned_" + this.dashboardFilterStatusLSKey;
      this.filterValues.global = this.stateService.unassigned_dashboard_filter;
    } else if (this.stateService.dashType == "assigned") {
      this.pageLocalStorageKey = "assigned_" + this.pageLocalStorageKey;
      this.dashboardFilterStatusLSKey = "assigned_" + this.dashboardFilterStatusLSKey;
      this.filterValues.global = this.stateService.assigned_dashboard_filter;
    } else {
      this.filterValues.global = this.stateService.dashboard_filter;
    }

    this.filterValues.status = JSON.parse(localStorage.getItem(this.dashboardFilterStatusLSKey) || '["OPEN"]');
    this.filterValuesStatusOldLength = this.filterValues.status.length;
    this.filterValuesStatusOld = this.filterValues.status;
    this.filterCaseStatusList = this.filterValues.status;

    if (this.stateService.user.role_id == UserRole.GAO_Admin || this.stateService.user.role_id == UserRole.GAO_Supervisor) this.showEmailButton = true;
    if (this.stateService.dashType == "assigned" || this.stateService.user.role_id == UserRole.GAO_Supervisor) this.showGroupAttorneyFilters = true;

    if (this.stateService.user.globalEmailPref) this.emailButtonText = this.stateService.user.globalEmailPref == "Y" ? "OFF" : "ON";
    if (this.stateService.user.role_id != UserRole.GAO_Admin) {
      this.showUserInvitations();
    }
    this.checkPasswordExpiry();

    this.setDisplayedColumns();
    this.loadDashboard();
  }

  showUserInvitations() {
    this.httpService.Get<IUList>('/secondary-rep-invites').subscribe((response) => {
      let invitedUserList = response?.invitedUserList;
      if (invitedUserList && invitedUserList.length > 0) {
        const dialogRef: MatDialogRef<UserInvitationsComponent> = this.dialog.open(UserInvitationsComponent, {
          data: invitedUserList,
          width: '600px',
        });
        dialogRef.afterClosed().subscribe(result => { });
      }
    });

  }
  checkPasswordExpiry() {
    if (this.stateService.loginResponse?.dto.passwordExpiring) {
      this.util.displayDialogMessage("Warning",
        "Your password is going to expire in " + this.stateService.loginResponse.dto.numOfDaysLeftToExpirePwd + "days. Do you want to update your password now?",
        {confirmText: "OK", cancelBtn: true, cancelText: "Update later"}).pipe()
        .subscribe(res => {
          this.stateService.loginResponse.dto.passwordExpiring = false;
          if (res) {
            this.router.navigate(['/user/change-pwd']);
          }
        });
    }

  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.sortingDataAccessor = this.util.sortingDataAccessor;
    this.dataSource.filterPredicate =  this.getFilterPredicate;

    if (this.util.checkROB()) {
      this.util.displayROB();
    } else if (this.util.checkPopup()) {
      this.util.displayPopup();
    }
    this.applyFilter();
  }

  ngOnDestroy() {
    if (this.stateService.dashType == "unassigned") {
      this.stateService.unassigned_dashboard_filter = this.filterValues.global;
    } else if (this.stateService.dashType == "assigned") {
      this.stateService.assigned_dashboard_filter = this.filterValues.global;
    } else {
      this.stateService.dashboard_filter = this.filterValues.global;
    }

    this.cancelLoad();
  }

  cancelLoad() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  loadDashboard(): void {
    const endLimit = localStorage.getItem(this.pageLocalStorageKey) || "25";
    var caseStatusList = this.filterValues.status ? this.filterValues.status.toString() : this.filterCaseStatusList.toString();
    if (caseStatusList.length == 0) caseStatusList = "CLOSED,COMPLETE,OPEN";  // if nothing selected, same as all selected
    const form = new FormData();
    if (this.alreadyAvailableANums) form.append("alreadyAvailableANums", this.alreadyAvailableANums);
    form.append("protestTableType", this.stateService.dashType);
    form.append("caseStatusList", caseStatusList);
    form.append("endLimit", endLimit);
    // form.append("isFullReloadReq","true");
    form.append("startLimit", "0");
    this.loading = true;
    this.httpService.Post<DashboardResponse>('/dashboard', form).pipe(
      takeUntil(this.ngUnsubscribe),
      catchError(err => {
        // console.log('Handling error locally.', err);
        this.loading = false;
        return throwError(err);
      })
    ).subscribe(response => {
      // console.log(response);

      if (response.caseStatusList && this.filterCaseStatusList.length != response.caseStatusList.length) {
        this.filterCaseStatusList = response.caseStatusList;
        this.filterCaseStatusList.sort();
      }

      if (response.protest_Info_List) {
        this.setSpecialClosedStatus(response.protest_Info_List);
        this.dataSource.data = [...this.dataSource.data, ...response.protest_Info_List];

        // build list so the filter works on child/supp B#s
        // Also build the alreadyAvailableANums
        for (let protest of response.protest_Info_List) {
          this.alreadyAvailableANums += this.alreadyAvailableANums ? "," + protest.a_No : protest.a_No;
          if (protest.supplemental_B_Nos) protest.searchChildBnos = protest.supplemental_B_Nos;
          if (protest.supplemental_A_Nos) this.alreadyAvailableANums += protest.supplemental_A_Nos;

          for (let child of protest.children_Protest_InfoList) {
            if (child.b_No) protest.searchChildBnos += ',' + child.b_No;
            this.alreadyAvailableANums += ',' + child.a_No;

            if (child.supplemental_B_Nos) protest.searchChildBnos += ',' + child.supplemental_B_Nos;
            if (child.supplemental_A_Nos) this.alreadyAvailableANums += child.supplemental_A_Nos;
          }

          if (!this.filterGroupList.includes(protest["attorney_Group_Id"])) {
            this.filterGroupList.push(protest["attorney_Group_Id"]);
            this.filterGroupList.sort();
          }
          if (!this.filterAttorneyList.includes(protest["attorney_Name"])) {
            this.filterAttorneyList.push(protest["attorney_Name"]);
            this.filterAttorneyList.sort();
          }
        }
        this.loadDashboard();
      } else {
        this.loading = false;
      }

    });
  }

  setSpecialClosedStatus(data:ProtestInfo[]) {
    data.forEach(row => {
      if (row.case_Status === "CLOSED" || row.case_Status === "RECENTLY CLOSED" || row.case_Status === "READY TO COMPLETE") {
        if (this.filterValues.status.includes("READY TO COMPLETE") && row.dmRTC)
          row.case_Status = "READY TO COMPLETE";
        else if (this.filterValues.status.includes("RECENTLY CLOSED") && row.public_decision_date == null)
          row.case_Status = "RECENTLY CLOSED";
        else
          row.case_Status = "CLOSED";
      }
    });
  }

  setDisplayedColumns() {
    //displayedColumns: string[] = ['b_No', 'company_Name', 'submission_Date', 'agency_Name', 'agencyRepInfos', 'due_Date', 'po',
    //     'a_No', 'attorney_Group_Id', 'attorney_Name', 'case_Type', 'case_Status'];
    if (this.stateService.dashType != "unassigned")
        this.displayedColumns.push('b_No');
    this.displayedColumns.push('company_Name', 'submission_Date', 'agency_Name');
    if (this.stateService.user.role_id == UserRole.Agency_Admin)
      this.displayedColumns.push('agencyRepInfos');
    this.displayedColumns.push('due_Date');
    if (this.stateService.user.role_id == UserRole.GAO_Attorney)
      this.displayedColumns.push('po');
    if (this.stateService.user.role_id != UserRole.GAO_Attorney)
      this.displayedColumns.push('a_No');
    if (this.stateService.dashType != "unassigned" || this.stateService.user.role_id == UserRole.GAO_Supervisor)
      this.displayedColumns.push('attorney_Group_Id', 'attorney_Name');
    this.displayedColumns.push('case_Type', 'case_Status');
  }

  applyFilter() {
    if (this.filterValuesStatusOld != this.filterValues.status) {
      this.cancelLoad();
      this.ngUnsubscribe = new Subject<void>();

      this.setSpecialClosedStatus(this.dataSource.data);

      this.loadDashboard();

      this.filterValuesStatusOld = this.filterValues.status;
      localStorage.setItem(this.dashboardFilterStatusLSKey, JSON.stringify(this.filterValues.status));
    }

    this.dataSource.filter = JSON.stringify(this.filterValues);
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  selectionFilter($event: MatSelectChange) {
    setTimeout(()=>{
      // console.log(this.filterValues.status);
      this.applyFilter();
    });
  }

  triggerFilter() {
    // the select all directive doesn't trigger an event when clearing, so having it emit an event to trigger it
    // console.log(this.filterValues.status);
    this.applyFilter();
  }

  eventFilter($event: Event) {
    // console.log(this.filterValues.status);
    this.applyFilter();
  }

  redirectToCaseDocket(protest: ProtestInfo) {
    this.caseDocketService.redirectToCaseDocket(protest);
  }

  private getFilterPredicate(data: ProtestInfo, filter: string) {
    // Built in Angular filtering only considers the column fields specified by the header name and not data in the field.
    // Copied the angular code and modified to add the child B#'s to the filter string.
    let dataStr = Object.keys(data)
      .reduce((currentTerm, key) => {
        return currentTerm + data[key as keyof ProtestInfo] + '◬';
      }, '').concat(data.searchChildBnos).toLowerCase();

    // Transform the filter by converting it to lowercase and removing whitespace.
    let searchTerms:FilterValues = JSON.parse(filter);
    searchTerms.global = searchTerms.global.trim().toLowerCase();
    return dataStr.indexOf(searchTerms.global) != -1
      && (searchTerms.group != undefined ? data.attorney_Group_Id == searchTerms.group : true)
      && (data.attorney_Name == null || data.attorney_Name.indexOf(searchTerms.user) != -1)
      && (searchTerms.status.length == 0 || searchTerms.status.includes(data.case_Status));
    // const transformedFilter = filter.trim().toLowerCase();
    // return dataStr.indexOf(transformedFilter) != -1;
  }

  onToggleEmailNotification() {
    // globalEmailPref undefined for admin and Y|N for supervisor
    let gep = this.stateService.user.globalEmailPref;
    if (this.stateService.user.globalEmailPref) {
      gep = this.stateService.user.globalEmailPref == 'Y' ? 'N' : 'Y';
    }

    this.httpService.Get<User>('/toggle-email-preferences/' + gep).pipe(
      catchError(err => {
        // console.log('Handling error locally.', err);
        return EMPTY;
      })
    ).subscribe(response => {
      // console.log(response);
      if (this.stateService.user.globalEmailPref) {
        this.stateService.user.globalEmailPref = gep;
        this.emailButtonText = this.stateService.user.globalEmailPref == "Y" ? "OFF" : "ON";
      }

    });
  }

}



